import { Record, Map, List } from 'immutable';
import { updateSortCode, updateBalanceAndCurrency } from './account-utils';
import { updateDate } from './date-utils';
var Account = Record({
  accountId: 'ACCOUNT ID IS MISSING',
  accountIdentification: Map(),
  availableBalance: '',
  balanceAt: '',
  currency: '',
  currentBalance: '',
  expectedBalance: '',
  balances: List(),
  overdraftLimit: '',
  overdraftRemaining: '',
  pendingTransactions: '',
  customerRelationshipCode: '',
  description: '',
  nameUnavailable: true,
  name: 'Account Name Unavailable',
  shortName: 'Account Short Name Unavailable',
  isClosed: false,
  accountType: null,
  type: '',
  totalFixedDeposits: 0,
  parentAccountIdentification: null
});
var buildDefaultAccountForId = function buildDefaultAccountForId(accountId) {
  return new Account({
    accountId: accountId
  });
};
var toRecord = function toRecord(account) {
  var acct = account.toObject();
  acct.nameUnavailable = !acct.name;
  return new Account(acct);
};
function parseAccounts() {
  var customerAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : List();
  return customerAccounts.map(updateBalanceAndCurrency).map(function (account) {
    return account.has('accountIdentification') ? updateSortCode(['accountIdentification', 'bban', 'sortCode'])(account) : account;
  }).map(updateSortCode(['parentAccountIdentification', 'bban', 'sortCode'])).map(updateDate(['balanceAt'])).update(sortAccounts).map(toRecord);
}
function sortAccounts(accounts) {
  return accounts.sortBy(function (a) {
    return a.getIn(['accountIdentification', 'iban']) || a.getIn(['accountIdentification', 'bban', 'accountNumber']) || a.getIn(['accountIdentification', 'pan', 'maskedPAN']);
  }).sortBy(function (a) {
    return a.get('name');
  });
}
export { Account, parseAccounts, buildDefaultAccountForId, toRecord };